import type { DateRange } from 'src/components/range-availability-calendar';

import type {
  ActivityDatePreference,
  ActivityDatePreferenceType,
} from './activity-date-preference.types';

const getPreferenceRanges = (
  preferences: ActivityDatePreference[],
  type: ActivityDatePreferenceType
): DateRange[] =>
  preferences
    .filter((preference) => preference.type === type)
    .map((preference) => ({
      from: preference.start.startOf('day'),
      to: preference.end.startOf('day'),
    }));

export function preferencesToCalendarRanges(preferences: ActivityDatePreference[]): {
  window: DateRange;
  preferred?: DateRange[];
  excluded?: DateRange[];
} {
  const completionWindow = preferences.find((preference) => preference.type === 'completionWindow');

  if (!completionWindow) {
    throw new Error('Activity date preferences must include a completion window row.');
  }

  const preferred = getPreferenceRanges(preferences, 'preferred');
  const excluded = getPreferenceRanges(preferences, 'excluded');

  return {
    window: { from: completionWindow.start, to: completionWindow.end },
    preferred: preferred.length > 0 ? preferred : undefined,
    excluded: excluded.length > 0 ? excluded : undefined,
  };
}
